import { select_virtel_where_parent_subkey } from "./frfr-virtel-selectors";


/*
FrFr FRIENDLY FRAMEWORK
frfr-virbom-utils
Version ID: 1a 2024-04-01r1
by 
// Please describe here if you customized this file
*/


export const virbomDetectLastSubkey = (arr, n) => {
  // detect largest integer used as .subkey property
  let max = 0;
  if (n > max) {
    max = n;
  }
  arr.forEach(item => {
    if (item && item.subkey > max) {
      max = item.subkey;
    }
  });
  return max;
};


//
export const virbom_convert_from_flat_to_nestedVirbomTree = (virbom_seq) => {
  // virbom hierarchical tree nested from flat (normalized)
  let nestedVirbomTree = [];
  if (Array.isArray(virbom_seq) && virbom_seq[0]) {
    //
    const _dirty_tree_virtel_single = (virtel, this_graphlevel) => {
      // pozivanje iteracija za children elemente
      const parent_subkey = virtel.subkey;
      const children_virtel_arr = select_virtel_where_parent_subkey(virbom_seq, parent_subkey);
      // console.log('children');
      // console.log(children_virtel_arr);
      let target_graphlevel = this_graphlevel + 1;
      const nested_children_arr = _dirty_tree_virtel_each(children_virtel_arr, target_graphlevel);
      // create virtel_with_nested_children
      return {
        self: virtel,
        nested_children: nested_children_arr
      };
    }; // end of _dirty_tree_virtel_single
    //
    const _dirty_tree_virtel_each = (_virtelArr, target_graphlevel) => {
      let _children_arr = [];
      _virtelArr.forEach((virtel) => {
        // console.log('each');
        // console.log(virtel);
        if (virtel.graphlevel === target_graphlevel) {
          const virtel_with_nested_children = _dirty_tree_virtel_single(virtel, target_graphlevel);
          _children_arr.push(virtel_with_nested_children);
        }
      });
      return _children_arr;
    }; // end of _dirty_tree_virtel_each
    //
    // startovanje iteracija pocev od level 1
    nestedVirbomTree = _dirty_tree_virtel_each(virbom_seq, 1, null);
  }
  return nestedVirbomTree;
};

